const LOADING_START_ACTION_REGEX = /(.+).REQUEST/i
const LOADING_STOP_ACTION_REGEX = /(.+)(.SUCCESS|.FAILURE)/i

export const getRequestNameByActionType = (
  actionType: string,
  regExp = LOADING_START_ACTION_REGEX
) => actionType.match(regExp)?.[1] ?? ''

// eslint-disable-next-line default-param-last
const loadingStatus = (state = {}, { type }: Record<'type', string>) => {
  switch (true) {
    case LOADING_START_ACTION_REGEX.test(type):
      return {
        ...state,
        [getRequestNameByActionType(type, LOADING_START_ACTION_REGEX)]: true,
      }
    case LOADING_STOP_ACTION_REGEX.test(type):
      return {
        ...state,
        [getRequestNameByActionType(type, LOADING_STOP_ACTION_REGEX)]: false,
      }
    default:
      return state
  }
}

export default loadingStatus
